import classnames from "classnames";
import { noop } from "lodash";
import { useFormContext } from "react-hook-form";
import type {
  QuizAttemptOption,
  QuizAttemptQuestion,
} from "@/react/types/QuizAttempt";
import type { QuizOption } from "@/react/types/QuizOption";
import type { QuizQuestion } from "@/react/types/QuizQuestion";
import { Form } from "@circle-react-uikit/Form";

const isQuizAttemptOption = (
  option: QuizOption | QuizAttemptOption,
): option is QuizAttemptOption => "selected" in option;

interface OptionItemProps {
  checkQuizCompleted: () => void;
  option: QuizOption | QuizAttemptOption;
  optionIndex: number;
  question: QuizQuestion | QuizAttemptQuestion;
  questionIndex: number;
  readOnly: boolean;
}
export const OptionItem = ({
  question,
  option,
  questionIndex,
  optionIndex,
  checkQuizCompleted,
  readOnly,
}: OptionItemProps) => {
  const name = `responses[${questionIndex}][selected_options][${optionIndex}][quizzes_option_id]`;
  const { setValue } = useFormContext();
  const onChange = (event: any) => {
    if (question.question_type === "multiple_choice") {
      setValue(name, event.target.checked ? option.id : undefined);
    } else {
      question.options.forEach((_option, index: number) => {
        setValue(
          `responses[${questionIndex}][selected_options][${index}][quizzes_option_id]`,
          index === optionIndex ? option.id : undefined,
        );
      });
    }
    checkQuizCompleted();
  };
  return (
    <Form.Item
      key={option.id}
      id={name}
      name={name}
      hideDescription
      hideBorder
      className="!mt-2 !flex flex-row-reverse items-center !p-0"
      label={option.value}
      labelClassName="!font-normal !mb-0 !mt-[1px]"
    >
      <Form.Checkbox
        // We want to submit the value of the option id, not true or false. Or do nothing if is readOnly
        onChange={readOnly ? noop : onChange}
        uncheckDisabled={readOnly}
        name={name}
        isRoundedFull={question.question_type === "single_choice"}
        className="!my-0"
        inputClassName={classnames({
          "disabled:!bg-toggle-inactive disabled:!border-transparent focus:!outline-none":
            readOnly,
          "hover:!bg-primary focus:!bg-primary":
            readOnly && isQuizAttemptOption(option) && !option.selected,
          "hover:!bg-toggle-inactive focus:!bg-toggle-inactive":
            readOnly && isQuizAttemptOption(option) && option.selected,
        })}
        {...(isQuizAttemptOption(option) && {
          checked: option.selected,
          disabled: option.selected,
        })}
      />
    </Form.Item>
  );
};
